import React from "react"

export const WelcomeReference = ({lastUpdateTitle, latestProfileData, studentsCount, referenceDesc }) => {
    return (<div className="cb-card   cards-section__child cards__references_group"
        data-cbtrack-comp="apricot-vanilla:card">
        <div className="cards__references">
            <div className="cards__last-update ">

                <h4 className="cb-h4">{lastUpdateTitle}</h4>
                <p className="cb-paragraph1-res">{latestProfileData}</p>

            </div></div>
        <div className="vertical-bar" />


        <div className="cards__references">
            <div className="cards__student-reference">

                <h3 className="cb-h4">{studentsCount}</h3>
                <p className="cb-paragraph1-res">{referenceDesc}</p>

            </div></div>

    </div>)
}